import React from 'react';
import { ServerError } from "../../constants";
import { hasServerError } from "../../infra/utils";
import ContactSupportButton from "../ContactSupportButton";
export const getGeneralErrorText = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Payment method connection failed. Please retry or ", /*#__PURE__*/React.createElement(ContactSupportButton, null), " for help."); // eslint-disable-next-line @typescript-eslint/no-explicit-any

export function mapErrorToMessage(error) {
  if (hasServerError(error, ServerError.BankTransferAccountBlocked)) {
    return 'Verification failed. The account you tried to connect is invalid for verification using micro-deposits. Please connect a different account.';
  } else {
    return getGeneralErrorText();
  }
}